/* global POLYFILL_PATH, SVG_PATH */
var config = window.cigna || {};
config.polyfillPath = typeof POLYFILL_PATH === 'undefined' ? '' : POLYFILL_PATH;
config.svgPath = typeof SVG_PATH === 'undefined' ? '' : SVG_PATH;
export var updateConfig = function updateConfig(cfg) {
  return Object.assign(config, cfg);
};
export default config;